import { render, staticRenderFns } from "./InstallationDetail_Event.vue?vue&type=template&id=278ed0ce&"
import script from "./InstallationDetail_Event.vue?vue&type=script&lang=js&"
export * from "./InstallationDetail_Event.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports